import { Layout } from '@/utils/routerHelper'

const mySportsMgtRouter = {
  path: '/my-sports-mgt',
  component: Layout, 
  alwaysShow: true, // will always show the root menu
  name: 'M_MY_SPORTS_MGT',
  meta: {
    // title: '我的赛事',
    // icon: 'clarity:user-line'
  },
  children: [
    {
      path: 'my-sports-list',
      component: () => import('@/views/sports-mgt/my-sports.vue'),
      name: 'M_MY_SPORTS_LIST',
      meta: {
        title: '我的报名',
        icon: 'clarity:certificate-outline-badged'
      }
    }
  ]
}

export default mySportsMgtRouter
